const id_master_goodsPrice = {

}

export default id_master_goodsPrice;